import { loadMoonPay } from '@moonpay/moonpay-js'

let pageTicker = document.querySelector('.how-buy-section__title .title-1')?.innerText.match(/\(([^)]+)\)/)?.[1]?.toLowerCase()

;(async _ => {
    const supportedListRaw = await (await fetch('https://api.moonpay.com/v3/currencies')).json()
    const renameList = { //when API data has different tickers
        bnb: "bnb_bsc",
        avax: "avax_cchain"
    }
    const exceptions = { //when our page has different tickers
        "dogegov.com": "doge"
    }
    const supportedList = supportedListRaw
        .filter(item => item.minBuyAmount)
        .map(item => {
            const rename = renameList[pageTicker] 
            const except = exceptions[pageTicker]
            if (item.code === 'bnb') console.log(rename)
            if (rename) return pageTicker = rename
            if (except) return pageTicker = except

            return item.code
        })
    const curTicker = supportedList.includes(pageTicker) ? pageTicker : 'btc'
    console.table({
        curTicker,
        pageTicker,
        isSupported: supportedList.includes(pageTicker)
    })
    console.log(supportedList)
    const moonPay = await loadMoonPay();
    const moonPaySdk = moonPay({
        flow: 'buy',
        environment: 'production',
        variant: 'embedded',
        containerNodeSelector: '#moonpay-form',
        params: {
            apiKey: 'pk_live_UB9TXwz7ATstU3EQpRyEFmG2eHw3TIHk',
            theme: 'light',
            colorCode: '#3692fe',
            defaultCurrencyCode: curTicker,
            baseCurrencyCode: 'usd',
            baseCurrencyAmount: 100
        }
    })

    moonPaySdk.show()
})()